import { render } from "./ShinyText.vue?vue&type=template&id=531130f1&scoped=true"
import script from "./ShinyText.vue?vue&type=script&lang=js"
export * from "./ShinyText.vue?vue&type=script&lang=js"

import "./ShinyText.vue?vue&type=style&index=0&id=531130f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531130f1"]])

export default __exports__